export type Colors =
  | 'text-current'
  | 'text-transparent'
  | 'text-ds-black' // = "black"
  | 'text-ds-natural' // = "#9B9AA2",
  | 'text-ds-natural-50' // = "#F9F9F9",
  | 'text-ds-natural-100' // = "#F1F1F3",
  | 'text-ds-natural-150' // = "#E4E3E7",
  | 'text-ds-natural-200' // = "#C9C8D0",
  | 'text-ds-natural-300' // = "#9B9AA2",
  | 'text-ds-natural-400' // = "#7F7E84",
  | 'text-ds-natural-500' // = "#5F5E65",
  | 'text-ds-natural-600' // = "#37363F",
  | 'text-ds-natural-700' // = "#29292F",
  | 'text-ds-natural-200-a' // = "#c9c8d033",
  | 'text-ds-natural-700-a' // = "#29292F99",
  | 'text-ds-primary' // = "#0078EF",
  | 'text-ds-primary-50' // = "#EDF9FF",
  | 'text-ds-primary-100' // = "#ABE3FF",
  | 'text-ds-primary-200' // = "#29A9FF",
  | 'text-ds-primary-300' // = "#0078EF",
  | 'text-ds-primary-400' // = "#005DE5",
  | 'text-ds-primary-500' // = "#0035A4",
  | 'text-ds-secondary' // = "#B75C19",
  | 'text-ds-secondary-100' // = "#FFE9A4",
  | 'text-ds-secondary-200' // = "#FFD074",
  | 'text-ds-secondary-300' // = "#FFB743",
  | 'text-ds-secondary-400' // = "#FF9D33",
  | 'text-ds-secondary-500' // = "#B75C19",
  | 'text-ds-accent1' // = "#FF73A9",
  | 'text-ds-accent1-100' // = "#FFD5E1",
  | 'text-ds-accent1-200' // = "#FF9DBE",
  | 'text-ds-accent1-300' // = "#FF73A9",
  | 'text-ds-accent1-400' // = "#F95396",
  | 'text-ds-accent1-500' // = "#B3297C",
  | 'text-ds-accent2' // = "#46E8A8",
  | 'text-ds-accent2-100' // = "#C8FBE7",
  | 'text-ds-accent2-200' // = "#75F5C4",
  | 'text-ds-accent2-300' // = "#46E8A8",
  | 'text-ds-accent2-400' // = "#38D695",
  | 'text-ds-accent2-500' // = "#1C9A7F",
  | 'text-ds-accent3' // = "#F4F3ED",
  | 'text-ds-accent3-100' // = "#FFFFFF",
  | 'text-ds-accent3-200' // = "#FCFBF7",
  | 'text-ds-accent3-300' // = "#F4F3ED",
  | 'text-ds-accent3-400' // = "#EAE8E1",
  | 'text-ds-accent3-500' // = "#E0DDD5",
  | 'text-ds-danger' // = "#D80000",
  | 'text-ds-danger-100' // = "#FDDBCA",
  | 'text-ds-danger-200' // = "#F37A61",
  | 'text-ds-danger-300' // = "#D80000",
  | 'text-ds-danger-400' // = "#B90010",
  | 'text-ds-danger-500' // = "#9B001A",
  | 'text-ds-marker-1' // = "#7B61FF",
  | 'text-ds-marker-2' // = "#8AFF96",
  | 'text-ds-marker-3' // = "#FF92F4",
  | 'text-ds-marker-4' // = "#FFF500",
  | 'text-ds-marker-5' // = "#71E5FF",
  | 'text-ds-marker-1-a' // = "#7b61ff12",
  | 'text-ds-marker-2-a' // = "#8AFF9612",
  | 'text-ds-marker-3-a' // = "#FF92F412",
  | 'text-ds-marker-4-a' // = "#FFF50012",
  | 'text-ds-marker-5-a'; // = "#71E5FF12",

export type BorderColors =
  | 'border-ds-black'
  | 'border-ds-accent3-100'
  | 'border-ds-natural' // = "#9B9AA2",
  | 'border-ds-natural-50' // = "#F9F9F9",
  | 'border-ds-natural-100' // = "#F1F1F3",
  | 'border-ds-natural-150' // = "#E4E3E7",
  | 'border-ds-natural-200' // = "#C9C8D0",
  | 'border-ds-natural-300' // = "#9B9AA2",
  | 'border-ds-natural-400' // = "#7F7E84",
  | 'border-ds-natural-500' // = "#5F5E65",
  | 'border-ds-natural-600' // = "#37363F",
  | 'border-ds-natural-700' // = "#29292F",
  | 'border-ds-natural-200-a' // = "#c9c8d033",
  | 'border-ds-natural-700-a' // = "#29292F99",
  | 'border-ds-primary' // = "#0078EF",
  | 'border-ds-primary-50' // = "#EDF9FF",
  | 'border-ds-primary-100' // = "#ABE3FF",
  | 'border-ds-primary-200' // = "#29A9FF",
  | 'border-ds-primary-300' // = "#0078EF",
  | 'border-ds-primary-400' // = "#005DE5",
  | 'border-ds-primary-500' // = "#0035A4",
  | 'border-ds-secondary' // = "#B75C19",
  | 'border-ds-secondary-100' // = "#FFE9A4",
  | 'border-ds-secondary-200' // = "#FFD074",
  | 'border-ds-secondary-300' // = "#FFB743",
  | 'border-ds-secondary-400' // = "#FF9D33",
  | 'border-ds-secondary-500' // = "#B75C19",
  | 'border-ds-accent1' // = "#FF73A9",
  | 'border-ds-accent1-100' // = "#FFD5E1",
  | 'border-ds-accent1-200' // = "#FF9DBE",
  | 'border-ds-accent1-300' // = "#FF73A9",
  | 'border-ds-accent1-400' // = "#F95396",
  | 'border-ds-accent1-500' // = "#B3297C",
  | 'border-ds-accent2' // = "#46E8A8",
  | 'border-ds-accent2-100' // = "#C8FBE7",
  | 'border-ds-accent2-200' // = "#75F5C4",
  | 'border-ds-accent2-300' // = "#46E8A8",
  | 'border-ds-accent2-400' // = "#38D695",
  | 'border-ds-accent2-500' // = "#1C9A7F",
  | 'border-ds-accent3' // = "#F4F3ED",
  | 'border-ds-accent3-100' // = "#FFFFFF",
  | 'border-ds-accent3-200' // = "#FCFBF7",
  | 'border-ds-accent3-300' // = "#F4F3ED",
  | 'border-ds-accent3-400' // = "#EAE8E1",
  | 'border-ds-accent3-500' // = "#E0DDD5",
  | 'border-ds-danger' // = "#D80000",
  | 'border-ds-danger-100' // = "#FDDBCA",
  | 'border-ds-danger-200' // = "#F37A61",
  | 'border-ds-danger-300' // = "#D80000",
  | 'border-ds-danger-400' // = "#B90010",
  | 'border-ds-danger-500' // = "#9B001A",
  | 'border-ds-marker-1' // = "#7B61FF",
  | 'border-ds-marker-2' // = "#8AFF96",
  | 'border-ds-marker-3' // = "#FF92F4",
  | 'border-ds-marker-4' // = "#FFF500",
  | 'border-ds-marker-5' // = "#71E5FF",
  | 'border-ds-marker-1-a' // = "#7b61ff12",
  | 'border-ds-marker-2-a' // = "#8AFF9612",
  | 'border-ds-marker-3-a' // = "#FF92F412",
  | 'border-ds-marker-4-a' // = "#FFF50012",
  | 'border-ds-marker-5-a'; // = "#71E5FF12",

export type BgColors =
  | 'bg-ds-black'
  | 'bg-ds-accent3-100'
  | 'bg-ds-natural' // = "#9B9AA2",
  | 'bg-ds-natural-50' // = "#F9F9F9",
  | 'bg-ds-natural-100' // = "#F1F1F3",
  | 'bg-ds-natural-150' // = "#E4E3E7",
  | 'bg-ds-natural-200' // = "#C9C8D0",
  | 'bg-ds-natural-300' // = "#9B9AA2",
  | 'bg-ds-natural-400' // = "#7F7E84",
  | 'bg-ds-natural-500' // = "#5F5E65",
  | 'bg-ds-natural-600' // = "#37363F",
  | 'bg-ds-natural-700' // = "#29292F",
  | 'bg-ds-natural-200-a' // = "#c9c8d033",
  | 'bg-ds-natural-700-a' // = "#29292F99",
  | 'bg-ds-primary' // = "#0078EF",
  | 'bg-ds-primary-50' // = "#EDF9FF",
  | 'bg-ds-primary-100' // = "#ABE3FF",
  | 'bg-ds-primary-200' // = "#29A9FF",
  | 'bg-ds-primary-300' // = "#0078EF",
  | 'bg-ds-primary-400' // = "#005DE5",
  | 'bg-ds-primary-500' // = "#0035A4",
  | 'bg-ds-secondary' // = "#B75C19",
  | 'bg-ds-secondary-50' // = "#FFF4D3",
  | 'bg-ds-secondary-100' // = "#FFE9A4",
  | 'bg-ds-secondary-200' // = "#FFD074",
  | 'bg-ds-secondary-300' // = "#FFB743",
  | 'bg-ds-secondary-400' // = "#FF9D33",
  | 'bg-ds-secondary-500' // = "#B75C19",
  | 'bg-ds-accent1' // = "#FF73A9",
  | 'bg-ds-accent1-100' // = "#FFD5E1",
  | 'bg-ds-accent1-200' // = "#FF9DBE",
  | 'bg-ds-accent1-300' // = "#FF73A9",
  | 'bg-ds-accent1-400' // = "#F95396",
  | 'bg-ds-accent1-500' // = "#B3297C",
  | 'bg-ds-accent2' // = "#46E8A8",
  | 'bg-ds-accent2-50' // = #DFFFF3
  | 'bg-ds-accent2-100' // = "#C8FBE7",
  | 'bg-ds-accent2-200' // = "#75F5C4",
  | 'bg-ds-accent2-300' // = "#46E8A8",
  | 'bg-ds-accent2-400' // = "#38D695",
  | 'bg-ds-accent2-500' // = "#1C9A7F",
  | 'bg-ds-accent3' // = "#F4F3ED",
  | 'bg-ds-accent3-100' // = "#FFFFFF",
  | 'bg-ds-accent3-200' // = "#FCFBF7",
  | 'bg-ds-accent3-300' // = "#F4F3ED",
  | 'bg-ds-accent3-400' // = "#EAE8E1",
  | 'bg-ds-accent3-500' // = "#E0DDD5",
  | 'bg-ds-danger' // = "#D80000",
  | 'bg-ds-danger-50' // = "##FFF2EC",
  | 'bg-ds-danger-100' // = "#FDDBCA",
  | 'bg-ds-danger-200' // = "#F37A61",
  | 'bg-ds-danger-300' // = "#D80000",
  | 'bg-ds-danger-400' // = "#B90010",
  | 'bg-ds-danger-500' // = "#9B001A",
  | 'bg-ds-marker-1' // = "#7B61FF",
  | 'bg-ds-marker-2' // = "#8AFF96",
  | 'bg-ds-marker-3' // = "#FF92F4",
  | 'bg-ds-marker-4' // = "#FFF500",
  | 'bg-ds-marker-5' // = "#71E5FF",
  | 'bg-ds-marker-1-a' // = "#7b61ff12",
  | 'bg-ds-marker-2-a' // = "#8AFF9612",
  | 'bg-ds-marker-3-a' // = "#FF92F412",
  | 'bg-ds-marker-4-a' // = "#FFF50012",
  | 'bg-ds-marker-5-a'; // = "#71E5FF12",

export const ColorNames: Record<string, Colors> = {
  black: 'text-ds-black',
  natural: 'text-ds-natural',
  natural50: 'text-ds-natural-50',
  natural100: 'text-ds-natural-100',
  natural150: 'text-ds-natural-150',
  natural200: 'text-ds-natural-200',
  natural300: 'text-ds-natural-300',
  natural400: 'text-ds-natural-400',
  natural500: 'text-ds-natural-500',
  natural600: 'text-ds-natural-600',
  natural700: 'text-ds-natural-700',
  natural200a: 'text-ds-natural-200-a',
  natural700a: 'text-ds-natural-700-a',
  primary: 'text-ds-primary',
  primary50: 'text-ds-primary-50',
  primary100: 'text-ds-primary-100',
  primary200: 'text-ds-primary-200',
  primary300: 'text-ds-primary-300',
  primary400: 'text-ds-primary-400',
  primary500: 'text-ds-primary-500',
  secondary: 'text-ds-secondary',
  secondary100: 'text-ds-secondary-100',
  secondary200: 'text-ds-secondary-200',
  secondary300: 'text-ds-secondary-300',
  secondary400: 'text-ds-secondary-400',
  secondary500: 'text-ds-secondary-500',
  accent1: 'text-ds-accent1',
  accent1100: 'text-ds-accent1-100',
  accent1200: 'text-ds-accent1-200',
  accent1300: 'text-ds-accent1-300',
  accent1400: 'text-ds-accent1-400',
  accent1500: 'text-ds-accent1-500',
  accent2: 'text-ds-accent2',
  accent2100: 'text-ds-accent2-100',
  accent2200: 'text-ds-accent2-200',
  accent2300: 'text-ds-accent2-300',
  accent2400: 'text-ds-accent2-400',
  accent2500: 'text-ds-accent2-500',
  accent3: 'text-ds-accent3',
  accent3100: 'text-ds-accent3-100',
  accent3200: 'text-ds-accent3-200',
  accent3300: 'text-ds-accent3-300',
  accent3400: 'text-ds-accent3-400',
  accent3500: 'text-ds-accent3-500',
  danger: 'text-ds-danger',
  danger100: 'text-ds-danger-100',
  danger200: 'text-ds-danger-200',
  danger300: 'text-ds-danger-300',
  danger400: 'text-ds-danger-400',
  danger500: 'text-ds-danger-500',
  marker1: 'text-ds-marker-1',
  marker2: 'text-ds-marker-2',
  marker3: 'text-ds-marker-3',
  marker4: 'text-ds-marker-4',
  marker5: 'text-ds-marker-5',
  marker1a: 'text-ds-marker-1-a',
  marker2a: 'text-ds-marker-2-a',
  marker3a: 'text-ds-marker-3-a',
  marker4a: 'text-ds-marker-4-a',
  marker5a: 'text-ds-marker-5-a',
};

export const BorderColorsNames = {
  black: 'border-ds-black',
  natural: 'border-ds-natural',
  natural50: 'border-ds-natural-50',
  natural100: 'border-ds-natural-100',
  natural150: 'border-ds-natural-150',
  natural200: 'border-ds-natural-200',
  natural300: 'border-ds-natural-300',
  natural400: 'border-ds-natural-400',
  natural500: 'border-ds-natural-500',
  natural600: 'border-ds-natural-600',
  natural700: 'border-ds-natural-700',
  natural200a: 'border-ds-natural-200-a',
  natural700a: 'border-ds-natural-700-a',
  primary: 'border-ds-primary',
  primary50: 'border-ds-primary-50',
  primary100: 'border-ds-primary-100',
  primary200: 'border-ds-primary-200',
  primary300: 'border-ds-primary-300',
  primary400: 'border-ds-primary-400',
  primary500: 'border-ds-primary-500',
  secondary: 'border-ds-secondary',
  secondary100: 'border-ds-secondary-100',
  secondary200: 'border-ds-secondary-200',
  secondary300: 'border-ds-secondary-300',
  secondary400: 'border-ds-secondary-400',
  secondary500: 'border-ds-secondary-500',
  accent1: 'border-ds-accent1',
  accent1100: 'border-ds-accent1-100',
  accent1200: 'border-ds-accent1-200',
  accent1300: 'border-ds-accent1-300',
  accent1400: 'border-ds-accent1-400',
  accent1500: 'border-ds-accent1-500',
  accent2: 'border-ds-accent2',
  accent2100: 'border-ds-accent2-100',
  accent2200: 'border-ds-accent2-200',
  accent2300: 'border-ds-accent2-300',
  accent2400: 'border-ds-accent2-400',
  accent2500: 'border-ds-accent2-500',
  accent3: 'border-ds-accent3',
  accent3100: 'border-ds-accent3-100',
  accent3200: 'border-ds-accent3-200',
  accent3300: 'border-ds-accent3-300',
  accent3400: 'border-ds-accent3-400',
  accent3500: 'border-ds-accent3-500',
  danger: 'border-ds-danger',
  danger100: 'border-ds-danger-100',
  danger200: 'border-ds-danger-200',
  danger300: 'border-ds-danger-300',
  danger400: 'border-ds-danger-400',
  danger500: 'border-ds-danger-500',
  marker1: 'border-ds-marker-1',
  marker2: 'border-ds-marker-2',
  marker3: 'border-ds-marker-3',
  marker4: 'border-ds-marker-4',
  marker5: 'border-ds-marker-5',
  marker1a: 'border-ds-marker-1-a',
  marker2a: 'border-ds-marker-2-a',
  marker3a: 'border-ds-marker-3-a',
  marker4a: 'border-ds-marker-4-a',
  marker5a: 'border-ds-marker-5-a',
};

export const BgColorsNames: Record<string, BgColors> = {
  black: 'bg-ds-black',
  natural: 'bg-ds-natural',
  natural50: 'bg-ds-natural-50',
  natural100: 'bg-ds-natural-100',
  natural150: 'bg-ds-natural-150',
  natural200: 'bg-ds-natural-200',
  natural300: 'bg-ds-natural-300',
  natural400: 'bg-ds-natural-400',
  natural500: 'bg-ds-natural-500',
  natural600: 'bg-ds-natural-600',
  natural700: 'bg-ds-natural-700',
  natural200a: 'bg-ds-natural-200-a',
  natural700a: 'bg-ds-natural-700-a',
  primary: 'bg-ds-primary',
  primary50: 'bg-ds-primary-50',
  primary100: 'bg-ds-primary-100',
  primary200: 'bg-ds-primary-200',
  primary300: 'bg-ds-primary-300',
  primary400: 'bg-ds-primary-400',
  primary500: 'bg-ds-primary-500',
  secondary: 'bg-ds-secondary',
  secondary100: 'bg-ds-secondary-100',
  secondary200: 'bg-ds-secondary-200',
  secondary300: 'bg-ds-secondary-300',
  secondary400: 'bg-ds-secondary-400',
  secondary500: 'bg-ds-secondary-500',
  accent1: 'bg-ds-accent1',
  accent1100: 'bg-ds-accent1-100',
  accent1200: 'bg-ds-accent1-200',
  accent1300: 'bg-ds-accent1-300',
  accent1400: 'bg-ds-accent1-400',
  accent1500: 'bg-ds-accent1-500',
  accent2: 'bg-ds-accent2',
  accent2100: 'bg-ds-accent2-100',
  accent2200: 'bg-ds-accent2-200',
  accent2300: 'bg-ds-accent2-300',
  accent2400: 'bg-ds-accent2-400',
  accent2500: 'bg-ds-accent2-500',
  accent3: 'bg-ds-accent3',
  accent3100: 'bg-ds-accent3-100',
  accent3200: 'bg-ds-accent3-200',
  accent3300: 'bg-ds-accent3-300',
  accent3400: 'bg-ds-accent3-400',
  accent3500: 'bg-ds-accent3-500',
  danger: 'bg-ds-danger',
  danger100: 'bg-ds-danger-100',
  danger200: 'bg-ds-danger-200',
  danger300: 'bg-ds-danger-300',
  danger400: 'bg-ds-danger-400',
  danger500: 'bg-ds-danger-500',
  marker1: 'bg-ds-marker-1',
  marker2: 'bg-ds-marker-2',
  marker3: 'bg-ds-marker-3',
  marker4: 'bg-ds-marker-4',
  marker5: 'bg-ds-marker-5',
  marker1a: 'bg-ds-marker-1-a',
  marker2a: 'bg-ds-marker-2-a',
  marker3a: 'bg-ds-marker-3-a',
  marker4a: 'bg-ds-marker-4-a',
  marker5a: 'bg-ds-marker-5-a',
};

export const ColorHex: Record<string, `#${string}`> = {
  black: '#000', //"text-ds-black",
  natural: '#9B9AA2', //"text-ds-natural",
  natural50: '#F9F9F9', //"text-ds-natural-50",
  natural100: '#F1F1F3', //"text-ds-natural-100",
  natural150: '#E4E3E7', //"text-ds-natural-150",
  natural200: '#C9C8D0', //"text-ds-natural-200",
  natural300: '#9B9AA2', //"text-ds-natural-300",
  natural400: '#7F7E84', //"text-ds-natural-400",
  natural500: '#5F5E65', //"text-ds-natural-500",
  natural600: '#37363F', //"text-ds-natural-600",
  natural700: '#29292F', //"text-ds-natural-700",
  natural200a: '#C9C8D033', //"text-ds-natural-200-a",
  natural700a: '#29292F99', //"text-ds-natural-700-a",
  primary: '#0078EF', //"text-ds-primary",
  primary50: '#EDF9FF', //"text-ds-primary-50",
  primary100: '#ABE3FF', //"text-ds-primary-100",
  primary200: '#29A9FF', //"text-ds-primary-200",
  primary300: '#0078EF', //"text-ds-primary-300",
  primary400: '#005DE5', //"text-ds-primary-400",
  primary500: '#0035A4', //"text-ds-primary-500",
  secondary: '#FFB743', //"text-ds-secondary",
  secondary100: '#FFE9A4', //"text-ds-secondary-100",
  secondary200: '#FFD074', //"text-ds-secondary-200",
  secondary300: '#FFB743', //"text-ds-secondary-300",
  secondary400: '#FF9D33', //"text-ds-secondary-400",
  secondary500: '#B75C19', //"text-ds-secondary-500",
  accent1: '#FF73A9', //"text-ds-accent1",
  accent1100: '#FFD5E1', //"text-ds-accent1-100",
  accent1200: '#FF9DBE', //"text-ds-accent1-200",
  accent1300: '#FF73A9', //"text-ds-accent1-300",
  accent1400: '#F95396', //"text-ds-accent1-400",
  accent1500: '#B3297C', //"text-ds-accent1-500",
  accent2: '#46E8A8', //"text-ds-accent2",
  accent2100: '#C8FBE7', //"text-ds-accent2-100",
  accent2200: '#75F5C4', //"text-ds-accent2-200",
  accent2300: '#46E8A8', //"text-ds-accent2-300",
  accent2400: '#38D695', //"text-ds-accent2-400",
  accent2500: '#1C9A7F', //"text-ds-accent2-500",
  accent3: '#F4F3ED', //"text-ds-accent3",
  accent3100: '#FFFFFF', //"text-ds-accent3-100",
  accent3200: '#FCFBF7', //"text-ds-accent3-200",
  accent3300: '#F4F3ED', //"text-ds-accent3-300",
  accent3400: '#EAE8E1', //"text-ds-accent3-400",
  accent3500: '#E0DDD5', //"text-ds-accent3-500",
  danger: '#D80000', //"text-ds-danger",
  danger100: '#FDDBCA', //"text-ds-danger-100",
  danger200: '#F37A61', //"text-ds-danger-200",
  danger300: '#D80000', //"text-ds-danger-300",
  danger400: '#B90010', //"text-ds-danger-400",
  danger500: '#9B001A', //"text-ds-danger-500",
  marker1: '#7B61FF', //"text-ds-marker-1",
  marker2: '#8AFF96', //"text-ds-marker-2",
  marker3: '#FF92F4', //"text-ds-marker-3",
  marker4: '#FFF500', //"text-ds-marker-4",
  marker5: '#71E5FF', //"text-ds-marker-5",
  marker1a: '#7b61ff12', //"text-ds-marker-1-a",
  marker2a: '#8AFF9612', //"text-ds-marker-2-a",
  marker3a: '#FF92F412', //"text-ds-marker-3-a",
  marker4a: '#FFF50012', //"text-ds-marker-4-a",
  marker5a: '#71E5FF12', //"text-ds-marker-5-a",
};
